import React from 'react';
import cx from 'classnames';

import Breadcrumbs from '@magoosh/layouts/components/breadcrumbs';
import Container from '@magoosh/layouts/components/container';
import LoadingIndicator from '@magoosh/layouts/components/loading_indicator';
import { BreadcrumbProps } from '@magoosh/layouts/types';
import { BannerAlert, InfoAlert } from '@magoosh/lib/alerts';

import style from './style.module.scss';

interface Props {
  breadcrumbs?: BreadcrumbProps[];
  className?: string;
  linkComponent?: React.ComponentType<any>;
  loading?: boolean;
  notices?: {
    content: string;
    type: 'banner' | 'info';
  }[];
  style?: any;
}

const CardLayout: (React.FC<Props> & { Card: any }) = (props) => {
  const containerStyle = {} as any;
  return (
    <div className={cx(style.page, props.className)} style={props.style}>
      <Container id="resizeable-container">
        {
          (props.notices || []).length > 0 && (
            <div className="d-flex flex-column gap-s u-margin-T-l">
              {
                props.notices.map((notice, idx) => {
                  let Alert = InfoAlert;

                  if (notice.type === 'banner') {
                    Alert = BannerAlert;
                  } else if (notice.type === 'info') {
                    Alert = InfoAlert;
                  }

                  return (
                    <Alert key={idx}>
                      <div dangerouslySetInnerHTML={{ __html: notice.content }} />
                    </Alert>
                  );
                })
              }
            </div>
          )
        }

        {
          props.breadcrumbs && (
            <Breadcrumbs breadcrumbs={props.breadcrumbs} linkComponent={props.linkComponent} />
          )
        }

        {
          props.loading ? (
            <div className="d-flex justify-content-center u-margin-T-l">
              <LoadingIndicator />
            </div>
          ) : typeof props.children === 'function' ? (props.children as any)({ loading: props.loading }) : props.children
        }
      </Container>
    </div>
  );
};

CardLayout.Card = (props) => {
  return (
    <div className={cx(style.pageCard, props.className)} style={props.style}>
      {props.children}
    </div>
  );
};

export default CardLayout;
